import { StorefrontProductPurchaseCard } from '@emporion/ui'

type Props = {
  formatCurrency: (value: number) => string
  priceExVat: number
  priceIncVat: number
  availabilityLabel: string
  availabilityTone: 'ok' | 'warn' | 'critical' | 'info'
  availabilityText: string
  cartQuantity: number
  disableQuantityControls: boolean
  disableAddToCart: boolean
  addToCartLabel: string
  addToCartMessage: string
  addToCartMessageTone: 'success' | 'error' | null
  onIncreaseCartQuantity: () => void
  onDecreaseCartQuantity: () => void
  onAddToCart: () => void
  onShareProduct?: () => void
  disableShareAction?: boolean
}

const ProductPurchaseCard = ({
  formatCurrency,
  priceExVat,
  priceIncVat,
  availabilityLabel,
  availabilityTone,
  availabilityText,
  cartQuantity,
  disableQuantityControls,
  disableAddToCart,
  addToCartLabel,
  addToCartMessage,
  addToCartMessageTone,
  onIncreaseCartQuantity,
  onDecreaseCartQuantity,
  onAddToCart,
  onShareProduct,
  disableShareAction = false,
}: Props) => {
  return (
    <StorefrontProductPurchaseCard
      formatCurrency={formatCurrency}
      priceExVat={priceExVat}
      priceIncVat={priceIncVat}
      availabilityLabel={availabilityLabel}
      availabilityTone={availabilityTone}
      availabilityText={availabilityText}
      cartQuantity={cartQuantity}
      disableQuantityControls={disableQuantityControls}
      disableAddToCart={disableAddToCart}
      addToCartLabel={addToCartLabel}
      addToCartMessage={addToCartMessage}
      addToCartMessageTone={addToCartMessageTone}
      onIncreaseCartQuantity={onIncreaseCartQuantity}
      onDecreaseCartQuantity={onDecreaseCartQuantity}
      onAddToCart={onAddToCart}
      onShareProduct={onShareProduct}
      disableShareAction={disableShareAction}
    />
  )
}

export default ProductPurchaseCard
